import React from 'react';
import { useAppSelector } from 'hooks';
import ReactSelect from 'react-select';

import { InputProps } from '~components/form-fields';
import { Option } from '~components/Select';

import { selectAppointmentCancellationReasons } from '~appointments/selectors/cancellationReasons';

interface NdisOption extends Option {
  ndis?: boolean;
}

const AppointmentCancellationReason: React.FC<InputProps> = ({ id, onChange, value }) => {
  const cancellationReasons = useAppSelector(selectAppointmentCancellationReasons);

  // Apply margin for NDIS options in the menu
  const formatGroupedOptions = (option: NdisOption, { context }: { context: string }) => {
    if (context === 'menu') {
      return <div className={option.ndis ? 'ms-3' : ''}>{option.label}</div>;
    }
    return <div>{option.label}</div>;
  };

  const ndisReasons = cancellationReasons.filter((reason) => reason.package === 'ndis');
  const regularReasons = cancellationReasons.filter((reason) => reason.package !== 'ndis');

  const createOption = (reason: (typeof cancellationReasons)[number]) => ({
    value: reason.name,
    label: reason.name,
    ...(reason.package === 'ndis' ? { ndis: true } : {}),
  });

  const ndisOptions = ndisReasons.map(createOption);
  const regularOptions = regularReasons.map(createOption);

  const options = [];

  if (ndisOptions.length > 0) {
    options.push({
      label: 'NDIS Cancellation Reasons',
      options: ndisOptions,
    });
  }

  regularOptions.forEach((option) => {
    options.push(option);
  });

  // Combine all options for value matching
  const allOptions = [...ndisOptions, ...regularOptions];

  return (
    <div className="align-items-center row" data-cy={`${id}-select`}>
      <div className="col">
        <ReactSelect
          id={id}
          name={id}
          value={allOptions.find((option) => option.value === value) || null}
          options={options}
          classNamePrefix="form-input-select"
          onChange={(option) => {
            onChange && onChange(id, option?.value ?? null);
          }}
          formatOptionLabel={formatGroupedOptions}
          placeholder="-"
        />
      </div>
    </div>
  );
};

export default AppointmentCancellationReason;
